export enum WebhookEvent {
  // BoomScreen
  ApplicationApproved = "application_approved",
  ApplicationConditionallyApproved = "application_conditionally_approved",
  ApplicantCreated = "applicant_created",
  ApplicantCompleted = "applicant_completed",
  ApplicationCreated = "application_created",
  ApplicationCompleted = "application_completed",
  // BoomReport
  CustomerRegistered = "boomreport_customer_registered",
  CustomerUnenrolled = "boomreport_customer_unenrolled",
  EnrollmentPending = "boomreport_enrollment_pending",
  EnrollmentApproved = "boomreport_enrollment_approved",
  EnrollmentRejected = "boomreport_enrollment_rejected",
  IssuePending = "boomreport_issue_pending",
  IssueResolved = "boomreport_issue_resolved",
  FurnishmentFinished = "boomreport_furnishment_finished",
  RentalPaymentVerified = "boomreport_rental_payment_verified",
  EnrollmentVerificationVerified = "boomreport_enrollment_verification_verified",
  EnrollmentVerificationRejected = "boomreport_enrollment_verification_rejected",
  EnrollmentMovedOut = "boomreport_enrollment_moved_out"

  // Chime release
  // RentalPaymentThroughPortalDetected = "boomreport_customer_rental_payment_through_portal_detected",
  // RentalPaymentVerified = "boomreport_rental_payment_verified"
}

export const boomreportWebhookEvents = {
  [WebhookEvent.CustomerRegistered]: "Customer registered",
  [WebhookEvent.CustomerUnenrolled]: "Customer unenrolled",
  // [WebhookEvent.RentalPaymentThroughPortalDetected]:
  //   "Rental payment through portal detected",
  [WebhookEvent.EnrollmentPending]: "Enrollment pending",
  [WebhookEvent.EnrollmentApproved]: "Enrollment approved",
  [WebhookEvent.EnrollmentRejected]: "Enrollment rejected",
  [WebhookEvent.IssuePending]: "Issue pending",
  [WebhookEvent.IssueResolved]: "Issue resolved",
  [WebhookEvent.FurnishmentFinished]: "Furnishment finished",
  [WebhookEvent.RentalPaymentVerified]: "Rental payment verified",
  [WebhookEvent.EnrollmentVerificationVerified]:
    "Enrollment verification verified",
  [WebhookEvent.EnrollmentVerificationRejected]:
    "Enrollment verification rejected",
  [WebhookEvent.EnrollmentMovedOut]: "Moved out"
};

export const boomscreenWebhookEvents = {
  [WebhookEvent.ApplicationApproved]: "Application approved",
  [WebhookEvent.ApplicationConditionallyApproved]:
    "Application conditionally approved",
  [WebhookEvent.ApplicantCreated]: "Applicant created",
  [WebhookEvent.ApplicantCompleted]: "Applicant completed",
  [WebhookEvent.ApplicationCreated]: "Application created",
  [WebhookEvent.ApplicationCompleted]: "Application completed"
};

export const webhookEvents = {
  ...boomreportWebhookEvents,
  ...boomscreenWebhookEvents
};

export type Webhook = {
  created_at: string;
  id: number;
  status: "active" | "inactive";
  token?: string;
  event_name: WebhookEvent;
  updated_at: string;
  url: string;
};
